import React, { useEffect ,useState } from 'react'
import Chart from "react-apexcharts";
export default function P302Chart({data}) {
    
    const [show, setShow] = useState(false);
    const dataConf = {
        options: {
            chart: {
                id: "basic-bar",
                toolbar: {
                    show: false
                }
            },
            grid: {
                show: true,
                padding: {
                    top: 0,
                    right: 10,
                    bottom: 0,
                    left: 10
                }, 
                xaxis: {
                    lines: {
                        show: true
                    }
                },   
                yaxis: {
                    lines: {
                        show: true
                    }
                },  
            },
            xaxis: {
                categories: data.seriesList , 
                labels:{
                    show: true,
                    showAlways: true,
                    offsetX: 0,
                    offsetY: 0,
                },
                
            },
            yaxis: {
                show: data.seriesList && data.seriesList.length > 0 ?true:false,
                opposite: false,
                labels:{
                    show: true,
                    showAlways: true,
                    offsetX: 0,
                    offsetY: 0,
                    align: 'right',
                    maxWidth: 500,
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#78909C',
                    width: 6,
                    offsetX: 0,
                    offsetY: 0
                }, 
                
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                    barHeight: '50%',
                },
            },
            dataLabels: {
                enabled: true,
                hideOverflowingLabels : true,
            },
        },
        series: [
            {
                name: "ล้านบาท",
                data: data.valList,
            },
        ],
    };

    useEffect(() => {
        if(data ){
            setShow(true) 
        }
    }, [data])

    return (
        <div>
            <div className="card"  >
                {/* <h5>Horizontal</h5> style={{width:'80%'}} */}
                {
                    show === true ?(
                        <Chart options={dataConf.options} series={dataConf.series} type="bar" 
                        height="250px" 
                         />
                    ):('')
                }
            </div>
        </div>
    )
}
